export const FACEBOOK_URL = 'https://www.facebook.com/sharer/sharer.php?u=';

export const TWITTER_URL = 'https://twitter.com/intent/tweet?text=';
